import IframeResizer from "iframe-resizer-react";
import React, { useRef, useEffect, useMemo } from "react";

export default function ResizableIframe({ className, html, ...props }) {
  return (
    <IframeResizer
      {...props}
      heightCalculationMethod="lowestElement"
      checkOrigin={false}
      srcDoc={`<script src="${process.env.PUBLIC_URL}/js/iframe-resizer.min.js"></script>${html}`}
      style={{ width: "1px", minWidth: "100%" }}
      className={className}
    />
  );
}
